import React from "react";
import logo from '../images/logo.jpeg';

export const Logo = () => (
    <img src={logo} alt="Our lovely logo" style={{maxWidth: '100%', height: 'auto'}}/>
)
